import React, { useState } from 'react';
import { useStore } from '../../store';
import { Folder, Plus, Trash2, Edit2, X } from 'lucide-react';

const ICONS = ['📁', '📂', '📋', '🚀', '💡', '🔥', '🎯', '🛠', '🧩', '📊', '🌟'];
const COLORS = ['#4f63ff', '#f59e0b', '#10b981', '#ef4444', '#a78bfa', '#f97316', '#06b6d4', '#ec4899'];

export default function CreateGroupModal({ onClose, projects }) {
  const [form, setForm] = useState({ name: '', icon: '📁', color: '#4f63ff' });
  const [loading, setLoading] = useState(false);
  const { createProjectGroup } = useStore();

  const submit = async e => {
    e.preventDefault();
    if (!form.name.trim()) return;
    setLoading(true);
    try {
      await createProjectGroup(form);
      onClose();
    } catch (err) {
      alert(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-backdrop" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal p-6 max-w-sm">
        <div className="flex items-center justify-between mb-5">
          <h2 className="text-lg font-semibold">Новая группа</h2>
          <button onClick={onClose} className="btn-ghost p-1"><X className="w-4 h-4" /></button>
        </div>

        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="label">Иконка</label>
            <div className="flex gap-1.5 flex-wrap">
              {ICONS.map(ic => (
                <button key={ic} type="button" onClick={() => setForm(p => ({ ...p, icon: ic }))}
                  className={`w-9 h-9 rounded-lg text-lg flex items-center justify-center transition-all ${form.icon === ic ? 'ring-2 ring-brand-500 bg-brand-50 dark:bg-brand-900' : 'hover:bg-gray-100 dark:hover:bg-gray-800'}`}>
                  {ic}
                </button>
              ))}
            </div>
          </div>

          <div>
            <label className="label">Цвет</label>
            <div className="flex gap-2">
              {COLORS.map(c => (
                <button key={c} type="button" onClick={() => setForm(p => ({ ...p, color: c }))}
                  className={`w-7 h-7 rounded-full transition-transform ${form.color === c ? 'scale-125 ring-2 ring-offset-1 ring-gray-400' : 'hover:scale-110'}`}
                  style={{ background: c }} />
              ))}
            </div>
          </div>

          <div>
            <label className="label">Название группы *</label>
            <input className="input" placeholder="Например: Активные проекты" value={form.name}
              onChange={e => setForm(p => ({ ...p, name: e.target.value }))} required autoFocus />
          </div>

          <div className="flex gap-2 pt-1">
            <button type="button" onClick={onClose} className="btn-secondary flex-1 justify-center">Отмена</button>
            <button type="submit" className="btn-primary flex-1 justify-center" disabled={loading}>
              {loading ? 'Создание...' : 'Создать'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
